export default __webpack_public_path__ + "static/media/linkedin.cfe7252b.svg";